import { Typography } from "@mui/material";
import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";
// import { useTheme } from "@mui/material/styles";
import theme from "./../theme";

const Login = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setloading] =useState(false);
  const history =useHistory();
  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    
  });
  const handelChange = (event) => {
    const { name, value } = event.target;
    setFormData((perData) => ({
      ...perData,
      [name]: value,
    }));
  };
  const login = async (formDataLogin) => {
   
    const validateFormData = validateInput(formDataLogin);
    if(validateFormData){
      console.log("passed");
    try {
      setloading(true)
      const data = await axios.post(`${config.endpoint}/auth/login`, {
        username: formDataLogin.username,
        password: formDataLogin.password,
      });
      if (data.data.success) {
        console.log("Logged in successfully");
        enqueueSnackbar("Logged in successfully",{variant:'success'})
        console.log(data); 
        persistLogin(data.data.token,data.data.username,data.data.balance)
        history.push("/")
      }
    } catch (error) {
      if(error.response && error.response.status === 400){
      console.log(error);
      console.log(error.response.data.message);
      enqueueSnackbar(`${error.response.data.message}`,{variant:'error'})
      }else{
        enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.")
        
      }
    }
    setloading(false)
  }

  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  const validateInput = (data) => {
    console.log(data);
    if(data.username===''){
      enqueueSnackbar("Username is a required field",{variant:"warning"})
      return false
    }
    if(data.password ===''){
      enqueueSnackbar("Password is a required field",{variant:"warning"})
      return false
    }
    return true
  };
  

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  const persistLogin = (token, username, balance) => {
 console.log(token,username,balance);
    localStorage.setItem("token",token);
    localStorage.setItem("username",username)
    localStorage.setItem("balance", balance)
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons />
      <Box className="content">
        <Stack spacing={2} className="form">
          {/* <Typography
            sx={{
              color: theme.palette.primary.dark,
              fontfamily: theme.typography.fontFamily,
            }}
            vaiant="h2"
            className="title"
          > */}
          <h2 className="title">
            Login</h2>
          {/* </Typography> */}
          <TextField
            id="usename"
            label="username"
            placeholder="Enter your username"
            onChange={handelChange}
            value={formData.username}
            name="username"
            type="text"
          />
          <TextField
            id="password"
            label="password"
            placeholder="Enter your password"
            onChange={handelChange}
            value={formData.password}
            name="password"
            type="password"
          />
          {
            loading ? 
            <CircularProgress/>:
            <Button
            variant="contained"
            onClick={() =>{login(formData)}}
            sx={{
              backgroundColor: theme.palette.primary.main,
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            LOGIN TO QKART
          </Button>
          }
          

          <Typography variant="body2">
            Don’t have an account?<Link to="/register" className="link">Register now</Link>
          </Typography>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
